//import { PreAuthorisationModel } from 'src/app/core/models/pre-authorisation.model';
import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, map, Observable, of, tap, throwError, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  EmploymentDetailsModel, JobTitle, LoanDocModel, PreAuthorisationModel, QuoteModel, SearchClientModel,
} from '@lmsModels';

import { CACHE_TTL, CACHING_ENABLED } from '../caching';
import { HistoryBean } from '../models/history-models';

@Injectable({
  providedIn: 'root',
})
export class ClientDetailsService {
  userBranch_apiURL = `${environment.apiUrl}/loan/api/user-branch`;
  client_apiURL = `${environment.apiUrl}/loan/api/client`;
  quote_apiURL = `${environment.apiUrl}/loan/api/quote`;
  idNumber: any;
  clientResult: any;
  preAuthorisationModel: PreAuthorisationModel;
  //quoteWorkbook: any;

  accessToken: any;

  HttpParamsOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  constructor(private httpClient: HttpClient) {}

  registerUser(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/register`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  loginCheck(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/login_check`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  userAcccount(data: any) {
    return this.httpClient
      .post(`${this.userBranch_apiURL}/user-acccount`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  getAllJobTitles() {
    return this.httpClient.get<JobTitle[]>(
      `${this.userBranch_apiURL}/getAllJobTitles`,
    );
  }

  searchUser(data: any): Observable<any | null> {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/searchUser`, data)
      .pipe(
        catchError(() => of(null)), // Graceful fallback
      );
  }

  resetUserPassword(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/reset-password`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  updateUser(data: any) {
    return this.httpClient
      .post<any>(`${this.userBranch_apiURL}/update`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  validateUserName(username: any) {
    return this.httpClient.post<any>(
      `${this.userBranch_apiURL}/validateuser`,
      username,
    );
    // .pipe(
    //   map((res: any) => {
    //     return res;
    //   })
    // );
  }

  getClientDetails(data: any) {
    return this.httpClient.post<any>(
      `${this.client_apiURL}/search`,
      data,
      this.HttpParamsOptions,
    );
    // .pipe(
    //   map((responseData: any) => {
    //     this.clientResult = responseData;
    //     return responseData;
    //   })
    // );
  }

  // this is same as endpoint call on quotestore service - getClientQuoteDetails
  // getClientQuoteDetails(data: any) {
  //   return this.httpClient
  //     .post<any>(`${this.quote_apiURL}/idNumber`, data)
  //     .pipe(
  //       map((responseData: any) => {
  //         return responseData;
  //       })
  //     )
  // }

  // return this.getClientHistoryRaw(data).subscribe({
  //   next: (responseData) => {
  //     map((responseData: any) => {
  //       this.clientHistoryResult = responseData;
  //       return responseData;
  //     });
  //   },
  // });

  getClientHistoryRaw(data: any) {
    return this.httpClient.post<any>(`${this.client_apiURL}/history`, data, {
      context: new HttpContext().set(CACHING_ENABLED, false),
    });
  }

  getClientHistory(data: {
    idNumber: string;
    fromQuoteId: number;
  }): Observable<HistoryBean> {
    return this.httpClient.post<HistoryBean>(
      `${this.client_apiURL}/internalhistory`,
      data,
      {
        context: new HttpContext()
          .set(CACHING_ENABLED, false)
          .set(CACHE_TTL, 60000), // 1 minute
      },
    );
  }

  applyForAnotherLoan(data: any) {
    return this.httpClient
      .post(`${this.client_apiURL}/applyForAnotherLoan`, data)
      .pipe(
        timeout({
          each: 180000,
          with: () => throwError(() => new Error('TimeOut occured')),
        }),
      );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  getUserBranchStatus(location: {latitude: number, longitude: number, branchSerial: string, consultantId: number}): Observable<any> {
    return this.httpClient.post(`${this.userBranch_apiURL}/userbranchstatus`, location, { responseType: 'text' } )
      .pipe(
        map((responseData: any) => {
          return responseData;
        })
      );
  }

  getClientByIdNumber(id: string): Observable<SearchClientModel> {
    return this.httpClient.get<SearchClientModel>(environment.apiUrl + id);
  }

  submitClientInformation(data: any) {
    return this.httpClient.post<any>(
      `${this.client_apiURL}/clientInformation`,
      data,
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  submitAffordability(data: any) {
    return this.httpClient.post<any>(
      `${this.client_apiURL}/affordability`,
      data,
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  saveChecklist(checklistObject: any) {
    return this.httpClient
      .post<any>(environment.apiUrl + '/document/checklist', checklistObject)
      .pipe(
        map((responseData: any) => {
          console.log(responseData);
          return responseData;
        }),
      );
  }

  // getFiles(): Observable<any> {
  //   return this.httpClient.get(`${environment.apiUrl}/files`);
  // }

  // uploadDocument(loanDoc: LoanDocModel): Observable<HttpEvent<any>> {
  //   const source$ = this.httpClient
  //     .post<any>(`${this.quote_apiURL}/saveDocument`, loanDoc)
  //     .pipe(tap({
  //       next(responseData) {
  //         return responseData;
  //       }
  //     }));
  //   return source$;
  // }

  uploadDocument(loanDoc: LoanDocModel) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/saveDocument`, loanDoc)
      .pipe(
        tap((responseData) => {
          return responseData;
        }),
      );
  }

  uploadDocumentWithProgress(loanDoc: LoanDocModel): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${this.quote_apiURL}/saveDocument`, loanDoc, {
      reportProgress: true,
    });
    return this.httpClient.request(req);
  }

  download(data: any) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/viewDocument`, data)
      .pipe(
        tap((responseData) => {
          console.log(responseData);
          return responseData;
        }),
      );
  }

  downloadRaw(data: any) {
    return this.httpClient.post<any>(`${this.quote_apiURL}/viewDocument`, data);
  }

  sendSms(data: any) {
    return this.httpClient.post<any>(`${this.client_apiURL}/sms`, data).pipe(
      tap((responseData) => {
        return responseData;
      }),
    );
  }

  //   sendSms(data: any) {
  //   return this.httpClient
  //     .post<any>(`${this.client_apiURL}/sms`, data)
  //     .pipe(
  //       map((responseData) => responseData.message), // Extract the message directly
  //       catchError((error) => {
  //         // Handle the error and return an observable with an error message
  //         return of(`Error: ${error.error ? error.error.message : 'An error occurred'}`);
  //       })
  //     );
  // }

  saveEmploymentDetails(data: any) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/saveEmployment`,
      data,
    );
    // .pipe(
    //   tap((res: any) => {
    //     return res;
    //   })
    // );
  }

  confirmEmploymentUpdate(data: EmploymentDetailsModel) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/confirmEmploymentUpdate`,
      data,
    );
    // .pipe(
    //   tap((res: any) => {
    //     return res;
    //   })
    // );
  }

  findCountries() {
    return this.httpClient.get<any>(`${this.client_apiURL}/countries`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findProvincies() {
    return this.httpClient.get<any>(`${this.client_apiURL}/provincies`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findOnboarding() {
    return this.httpClient.get<any>(`${this.client_apiURL}/onboarding`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 10 minute TTL for this request
    });
  }

  findDeliveryChanel() {
    return this.httpClient.get<any>(`${this.client_apiURL}/deliveryChanel`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findSourceOfFunds() {
    return this.httpClient.get<any>(`${this.client_apiURL}/sourceOfFunds`, {
      context: new HttpContext()
        .set(CACHING_ENABLED, true)
        .set(CACHE_TTL, 600000), // 1 minute
    });
  }

  findAll() {
    return this.httpClient.get<any>(`${this.client_apiURL}/findAll`);
  }

  // findCountryScore(natCountry: any) {
  //   return this.httpClient.
  //   get<any>(`${this.client_apiURL}/countryScore/' + natCountry);
  // }

  findEmployment() {
    return this.httpClient.get<any>(`${this.client_apiURL}/employment`);
  }

  findProduct() {
    return this.httpClient.get<any>(`${this.client_apiURL}/product`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findCustomer() {
    return this.httpClient.get<any>(`${this.client_apiURL}/customer`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findWeighting() {
    return this.httpClient.get<any>(`${this.client_apiURL}/weighting`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findNationalCountries() {
    return this.httpClient.get<any>(`${this.client_apiURL}/nationalCountries`, {
      context: new HttpContext().set(CACHING_ENABLED, true),
    });
  }

  findAddressById(id: any): any {
    return this.httpClient.get<any>(`${this.client_apiURL}/getAddress/${id}`);
  }

  listClientDocs(data: any): any {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/listDocuments`, data)
      .pipe(
        tap({
          next(value: any): any {
            return value;
          },
        }),
      );
  }

  listClientDocsByLoanReference(data: LoanDocModel | any): any {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/listDocumentsByLoanReference`, data)
      .pipe(
        tap({
          next(value: any): any {
            return value;
          },
        }),
      );
  }
  getDocChecklist(id: any) {
    return this.httpClient.get<any>(
      `${this.quote_apiURL}/getDocChecklist/${id}`,
    );
  }

  // deleteDocument(id: number): Observable<any> {
  //   return this.httpClient
  //     .delete(environment.apiDocUrl+'/document/api/docs/' + id)
  //    .pipe(
  //     map((responseData: any) => {
  //       return responseData;
  //     })
  //   );
  // }

  deleteDocument(data: any) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/deleteDoc`, data)
      .pipe(
        map((responseData: any) => {
          return responseData;
        }),
      );
  }

  findLoansToBeApproved() {
    return this.httpClient.get<any>(
      environment.apiUrl + '/loan/approver/loanqueue',
    );
  }

  getCallCentreQuoteDetails(data: any) {
    return this.httpClient
      .post<any>(environment.apiUrl + '/loan/approver/callCentreQuote', data)
      .pipe(
        map((responseData: any) => {
          return responseData;
        }),
      );
  }

  emidBankTransactionsTest(quoteModel: QuoteModel) {
    return this.httpClient
      .post<any>(`${this.quote_apiURL}/emidBankTransactions`, quoteModel)
      .pipe(
        map((responseData: any) => {
          return responseData;
        }),
      );
  }

  // checkLexisNexis(data: PreAuthorisationModel) {
  //   return this.httpClient
  //     .post<any>(`${this.client_apiURL}/lexisNexisSearch`, data)
  //     .pipe(
  //       map((responseData: any) => {
  //         return responseData;
  //       })
  //     );
  // }

  findEmploymentByName(data: any) {
    return this.httpClient.post<any>(
      `${this.quote_apiURL}/findEmployment`,
      data,
    );
    // .pipe(
    //   map((responseData: any) => {
    //     return responseData;
    //   })
    // );
  }

  sendToCompliance(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/sendToCompliance`, data)
      .pipe(
        map((responseData: any) => {
          return responseData;
        }),
      );
  }

  removeScorecard(id: any): Observable<any> {
    return this.httpClient
      .delete(`${this.client_apiURL}/removeScorecard/${id}`)
      .pipe(
        map((responseData: any) => {
          return responseData;
        }),
      );
  }

  getAllRegions() {
    return this.httpClient
      .get<any>(`${this.userBranch_apiURL}/getAllRegions`)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  getAllBranchesByRegion(region: any) {
    return this.httpClient
      .get<any>(`${this.userBranch_apiURL}/getAllBranchesByRegion/${region}`)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  findExistingComplianceData(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/fetchExistingComplianceData/`, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  validateIdNumber(data: any) {
    return this.httpClient
      .post<any>(`${this.client_apiURL}/validateIdNumber`, data)
      .pipe(
        tap((responseData) => {
          return responseData;
        }),
      );
  }

  setInterloanStatus(data: any) {
    return this.httpClient
      .post<any>(this.quote_apiURL + '/setInterloanStatus', data)
      .pipe(
        map((responseData) => {
          //this.excludeActionsData = responseData;
          return responseData;
        }),
      );
  }
}

